import { VIEW_URL_EXPIRES_IN_SECONDS } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

/** 서명 주소 수명(VIEW_URL_EXPIRES_IN_SECONDS, 1시간)의 0.8 배 — 창이 열린 동안 이 주기로 다시 받는다(뷰어 설계 V13). */
const DESIGN_VIEW_REFRESH_MS = (VIEW_URL_EXPIRES_IN_SECONDS * 1000 * 4) / 5;
/**
 * 서명 주소 수명의 0.1 배(6분) — 창을 다시 열 때 이보다 최근에 받은 뷰만 그대로 쓴다. 다시 연 창은 다음 주기까지 그 뷰를 쓰므로
 * 가장 오래된 주소는 수명의 0.1 + 0.8 = 0.9 배다(만료 전). 폰트는 만료(403)를 알 수 없어 대체 글꼴로 조용히 바뀌므로 수명 안에 둔다.
 */
const DESIGN_VIEW_STALE_MS = (VIEW_URL_EXPIRES_IN_SECONDS * 1000) / 10;

interface QuoteDesignViewOptions {
  /** 디자인 보기 창이 열려 있을 때만 true — 상세를 열자마자 뷰(서명 주소 묶음)를 받지 않는다. */
  readonly enabled: boolean;
}

/**
 * 견적 디자인 보기 뷰(quoteManagement.getDesignView, 뷰어 설계 V3) — 고정 편집영역 정의·폰트·잉크·고정 이미지의 서명 주소판.
 * 열려 있는 동안 주기적으로 다시 받아 오래 열어 둔 창에서도 재료가 깨지지 않게 하고, 창이 닫혀 관찰자가 없으면 멈춘다.
 * 없는 견적(NOT_FOUND)은 재시도해도 같으므로 다시 시도하지 않는다 — 창이 '다시 시도'를 보여 준다.
 */
export const useQuoteDesignViewQuery = (
  quoteRequestId: string,
  { enabled }: QuoteDesignViewOptions,
) =>
  trpc.quoteManagement.getDesignView.useQuery(
    { quoteRequestId },
    {
      enabled,
      refetchInterval: DESIGN_VIEW_REFRESH_MS,
      staleTime: DESIGN_VIEW_STALE_MS,
      retry: false,
    },
  );
